import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const MyTools = () => {
  const [purchasedTools, setPurchasedTools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPurchasedTools();
  }, []);

  const fetchPurchasedTools = async () => {
    const token = localStorage.getItem("jwt");
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      // Fetch user data to get the logged-in user's email
      const userRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/users/me`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const userEmail = userRes.data.email;

      // Fetch orders data
      const ordersRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/orders?filters[userEmail][$eq]=${userEmail}&filters[status][$eq]=successful&populate=tool`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Ensure `ordersRes.data` is not undefined and contains the expected `data` property
      if (ordersRes.data && Array.isArray(ordersRes.data)) {
        const validOrders = ordersRes.data.map((order) => ({
          amount: order.amount,
          tool: order.tool,
        }));
        setPurchasedTools(validOrders);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to load purchased tools");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-white">
        Loading...
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-screen flex items-center justify-center text-white">
        {error}
      </div>
    );
  }

  return (
    <div className="h-screen bg-gray-900 text-white">
      <header className="bg-gray-800 p-4 text-center text-2xl">
        My Purchased Tools
      </header>

      <div className="p-4 flex flex-wrap justify-center mt-6 gap-5">
        {purchasedTools.length === 0 ? (
          <div className="text-center text-gray-400">
            You haven't purchased any tools yet.
          </div>
        ) : (
          purchasedTools.map((order, index) => (
            <Link
              to="/our-tools"
              key={index}
              className="bg-gray-800 w-full sm:w-[300px] md:w-[350px] rounded-lg shadow-md p-4 mb-6 flex flex-col items-center"
            >
              <img
                src={order.tool.toolImage || "https://via.placeholder.com/150"}
                alt={order.tool.toolName}
                className="w-24 h-24 object-cover rounded-md mb-4"
              />
              <h2 className="text-lg font-semibold mb-2">
                {order.tool.toolName}
              </h2>
              <span className="text-blue-400 mb-2">₹{order.amount}</span>
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default MyTools;
